module.exports = __webpack_public_path__ + "img/loading.334b799.svg";